import { TP } from 'constants/index';

import { ENTITY_TYPES } from 'operabase-router/constants';

export const SUBSCRIPTION_PRODUCT_IDS = {
  // NOTE: Artist Products
  PROFILE_MONTHLY: 4,
  PROFILE_ANNUAL: 5,

  // NOTE: Independent Artist Products
  CASTING_TOOL: 74,
  ARCHIVE_ACCESS: 88,

  // NOTE: Now Legacy Concepts, points to TIER 2
  AOS: 81,
  AGENCY: 81,

  // NOTE: Organization Products
  PER_SEAT: 89,
  AOS_TIER_1: 91,
  AOS_TIER_2: 81,
  AOS_TIER_3: 78,
  AOS_TIER_4: 76,
  AOS_TIER_5: 82,
  AOS_TIER_6: 73,
};

export const PRODUCTS_WITH_CASTING_TOOL_ACCESS = [
  SUBSCRIPTION_PRODUCT_IDS.CASTING_TOOL,
  SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_1,
  SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_2,
  SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_3,
  SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_4,
  SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_5,
  SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_6,
];

export const PRODUCT_ID_PRECEDENCE_ORDER = [
  SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_1,
  SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_2,
  SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_3,
  SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_4,
  SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_5,
  SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_6,
  SUBSCRIPTION_PRODUCT_IDS.CASTING_TOOL,
  SUBSCRIPTION_PRODUCT_IDS.ARCHIVE_ACCESS,
  SUBSCRIPTION_PRODUCT_IDS.PROFILE_ANNUAL,
  SUBSCRIPTION_PRODUCT_IDS.PROFILE_MONTHLY,
  SUBSCRIPTION_PRODUCT_IDS.PER_SEAT,
];

export const SUBSCRIPTIONS_STATUSES = {
  active: 'active',
  cancelled: 'cancelled',
  expired: 'expired',
  nonRenewing: 'non_renewing',
  future: 'future',
  inTrial: 'in_trial',
  paused: 'paused',
  processing: 'processing',
  notActive: 'not_active',
};

export const SUBSCRIPTION_PAYMENT_STATUSES = {
  PAID: 'paid',
};

export const VALID_ENTITIES_FOR_SUBSCRIPTION_PRODUCTS = {
  [SUBSCRIPTION_PRODUCT_IDS.PROFILE_MONTHLY]: [ENTITY_TYPES.PROFILE],
  [SUBSCRIPTION_PRODUCT_IDS.PROFILE_ANNUAL]: [ENTITY_TYPES.PROFILE],
  [SUBSCRIPTION_PRODUCT_IDS.CASTING_TOOL]: [ENTITY_TYPES.PROFILE],
  [SUBSCRIPTION_PRODUCT_IDS.ARCHIVE_ACCESS]: [ENTITY_TYPES.PROFILE],
  [SUBSCRIPTION_PRODUCT_IDS.PER_SEAT]: [ENTITY_TYPES.ORGANIZATION, ENTITY_TYPES.AGENCY],
  [SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_1]: [ENTITY_TYPES.ORGANIZATION, ENTITY_TYPES.AGENCY],
  [SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_2]: [ENTITY_TYPES.ORGANIZATION, ENTITY_TYPES.AGENCY],
  [SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_3]: [ENTITY_TYPES.ORGANIZATION, ENTITY_TYPES.AGENCY],
  [SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_4]: [ENTITY_TYPES.ORGANIZATION, ENTITY_TYPES.AGENCY],
  [SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_5]: [ENTITY_TYPES.ORGANIZATION, ENTITY_TYPES.AGENCY],
  [SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_6]: [ENTITY_TYPES.ORGANIZATION, ENTITY_TYPES.AGENCY],
};

export const PAYMENT_CALLBACK_STATUSES = {
  SUCCESS: 'success',
};

export const PAYMENT_TYPES = {
  INVOICE: 'invoice',
  INSTANT: 'instant',
  PRICING_TABLE: 'pricing_table',
};

export const VALID_ENTITY_TYPE_SUBSCRIPTION_PRODUCTS = {
  [ENTITY_TYPES.PROFILE]: [
    SUBSCRIPTION_PRODUCT_IDS.PROFILE_MONTHLY,
    SUBSCRIPTION_PRODUCT_IDS.PROFILE_ANNUAL,
    SUBSCRIPTION_PRODUCT_IDS.CASTING_TOOL,
    SUBSCRIPTION_PRODUCT_IDS.ARCHIVE_ACCESS,
  ],
  [ENTITY_TYPES.ORGANIZATION]: [
    SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_1,
    SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_2,
    SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_3,
    SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_4,
    SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_5,
    SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_6,
  ],
  [ENTITY_TYPES.AGENCY]: [
    SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_1,
    SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_2,
    SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_3,
    SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_4,
    SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_5,
    SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_6,
  ],
};

export const SUBSCRIPTION_GROUP_IDENTIFIERS = {
  ARCHIVE_ACCESS: 'archive-access',
  ARTIST_PROFESSIONAL: 'artist-professional',
  CASTING_TOOL: 'casting-tool',
  ORG_PREMIUM: 'org-premium',
};

export const SUBSCRIPTION_GROUP_DETAILS = {
  [SUBSCRIPTION_GROUP_IDENTIFIERS.ARCHIVE_ACCESS]: {
    identifier: SUBSCRIPTION_GROUP_IDENTIFIERS.ARCHIVE_ACCESS,
    title: `${TP}.ARCHIVE_ACCESS_TITLE`,
    description: `${TP}.FN_ARCHIVE_PLAN_DESCRIPTION`,
    price: '€120',
    features: `${TP}.FN_ARCHIVE_ACCESS_PLAN_FEATURES`,
  },
  [SUBSCRIPTION_GROUP_IDENTIFIERS.ARTIST_PROFESSIONAL]: {
    identifier: SUBSCRIPTION_GROUP_IDENTIFIERS.ARTIST_PROFESSIONAL,
    title: `${TP}.FN_ARTIST_PROFESSIONAL_PROFILE`,
    description: `${TP}.FN_ARTIST_PLAN_DESCRIPTION`,
    price: '€120',
    priceOptions: [{ price: '€0' }, { price: '€15', isMonthly: true }, { price: '€120', isMonthly: false }],
    priceInclusions: `${TP}.FN_ARTIST_PLAN_PRICE_INCLUSIONS`,
    features: `${TP}.FN_ARTIST_PLAN_FEATURES`,
    featureTable: [
      {
        feature: `${TP}.ARCHIVE_ACCESS_TITLE`,
        prices: ['€120'],
      },
      {
        feature: `${TP}.PERFORMACE_VERFICATION`,
        prices: ['€120'],
      },
      {
        feature: `${TP}.FN_EDIT_FEAT_VISIBILITY_REPORT`,
        prices: ['€0', '€15', '€120'],
      },
      {
        feature: `${TP}.FN_EDIT_FEAT_VISIBILITY_BOOST`,
        prices: ['€15', '€120'],
      },
      {
        feature: `${TP}.FN_EDIT_FEAT_PROFILE_INFO`,
        prices: ['€0', '€15', '€120'],
      },
      {
        feature: `${TP}.FN_CONTACT_INFO_TITLE`,
        prices: ['€0', '€15', '€120'],
      },
      {
        feature: `${TP}.FN_FEATURE_ORIGINAL_WORKS`,
        prices: ['€0', '€15', '€120'],
      },
      {
        feature: `${TP}.FN_CREDITS`,
        prices: ['€0', '€15', '€120'],
      },
      {
        feature: `${TP}.FN_TAB_REPERTOIRE`,
        prices: ['€15', '€120'],
      },
      {
        feature: `${TP}.FN_FUTURE_REPRTOIRE`,
        prices: ['€15', '€120'],
      },
      {
        feature: `${TP}.m_IMAGES`,
        prices: ['€15', '€120'],
      },
      {
        feature: `${TP}.m_VIDEOS`,
        prices: ['€15', '€120'],
      },
      {
        feature: `${TP}.FN_TAB_REVIEWS`,
        prices: ['€15', '€120'],
      },
      {
        feature: `${TP}.FN_EDIT_FEAT_SOCIAL_MEDIA`,
        prices: ['€15', '€120'],
      },
      {
        feature: `${TP}.m_BIO`,
        prices: ['€15', '€120'],
      },
      {
        feature: `${TP}.FN_EDIT_FEAT_WORKED_WITH_PEOPLE`,
        prices: ['€15', '€120'],
      },
      {
        feature: `${TP}.FN_EDIT_FEAT_WORKED_WITH_ORG`,
        prices: ['€15', '€120'],
      },
      {
        feature: `${TP}.FN_EDIT_FEAT_WORKED_AT_VENUE`,
        prices: ['€15', '€120'],
      },
    ],
  },
  [SUBSCRIPTION_GROUP_IDENTIFIERS.CASTING_TOOL]: {
    identifier: SUBSCRIPTION_GROUP_IDENTIFIERS.CASTING_TOOL,
    title: `${TP}.CASTING_TOOL_PAYWALL_TITLE`,
    description: `${TP}.FN_CASTING_TOOL_PLAN_DESCRIPTION`,
    price: '€1500',
    features: `${TP}.FN_CASTING_TOOL_PLAN_FEATURES`,
    tools: `${TP}.FN_CASTING_PLAN_TOOLS`,
  },
  [SUBSCRIPTION_GROUP_IDENTIFIERS.ORG_PREMIUM]: {
    identifier: SUBSCRIPTION_GROUP_IDENTIFIERS.ORG_PREMIUM,
    title: `${TP}.FN_ORGANISATION_PREMIUM`,
    description: `${TP}.FN_ORG_PLAN_DESCRIPTION`,
    price: '€850 - €4000',
    features: `${TP}.FN_ORG_PLAN_FEATURES`,
    tools: `${TP}.FN_ORG_PLAN_TOOLS`,
  },
};

export const SUBSCRIPTION_PLANS = {
  [SUBSCRIPTION_GROUP_IDENTIFIERS.ARCHIVE_ACCESS]: [
    {
      productId: SUBSCRIPTION_PRODUCT_IDS.ARCHIVE_ACCESS,
      label: `${TP}.PAYMENTS_PRODUCT_ANNUAL`,
      price: '€120',
      inlinePricing: true,
    },
  ],
  [SUBSCRIPTION_GROUP_IDENTIFIERS.ARTIST_PROFESSIONAL]: [
    {
      productId: SUBSCRIPTION_PRODUCT_IDS.PROFILE_ANNUAL,
      label: `${TP}.PAYMENTS_PRODUCT_ANNUAL`,
      features: `${TP}.FN_ARTIST_PLAN_ANNUAL_FEATURES`,
      price: '€120',
      inlinePricing: true,
      canUpgrade: false,
      canDowngrade: true,
      tier: 1,
    },
    {
      productId: SUBSCRIPTION_PRODUCT_IDS.PROFILE_MONTHLY,
      label: `${TP}.PAYMENTS_PRODUCT_MONTHLY`,
      price: '€15',
      isMonthly: true,
      features: `${TP}.FN_ARTIST_PLAN_MONTHLY_FEATURES`,
      inlinePricing: true,
      canUpgrade: true,
      canDowngrade: false,
      tier: 2,
    },
  ],
  [SUBSCRIPTION_GROUP_IDENTIFIERS.CASTING_TOOL]: [
    {
      productId: SUBSCRIPTION_PRODUCT_IDS.CASTING_TOOL,
      label: `${TP}.FN_FOR_INDIVIDUALS`,
      price: '€1500',
      features: `${TP}.FN_CASTING_PLAN_INDIVIDUAL_FEATURES`,
    },
    {
      productGroup: SUBSCRIPTION_GROUP_IDENTIFIERS.ORG_PREMIUM,
      label: `${TP}.FN_FOR_ORGS`,
      price: '€850 - €4000',
      features: `${TP}.FN_CASTING_PLAN_ORG_FEATURES`,
    },
  ],
  [SUBSCRIPTION_GROUP_IDENTIFIERS.ORG_PREMIUM]: [
    {
      productId: SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_1,
      label: `${TP}.FN_ORG_PLAN_TIER_1_LABEL`,
      price: '€4000',
      features: `${TP}.FN_ORG_PLAN_TIER_1_FEATURES`,
      canUpgrade: false,
      canDowngrade: true,
      tier: 1,
    },
    {
      productId: SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_2,
      label: `${TP}.FN_ORG_PLAN_TIER_2_LABEL`,
      price: '€3000',
      features: `${TP}.FN_ORG_PLAN_TIER_2_FEATURES`,
      canUpgrade: true,
      canDowngrade: true,
      tier: 2,
    },
    {
      productId: SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_3,
      label: `${TP}.FN_ORG_PLAN_TIER_3_LABEL`,
      price: '€2000',
      features: `${TP}.FN_ORG_PLAN_TIER_3_FEATURES`,
      canUpgrade: true,
      canDowngrade: true,
      tier: 3,
    },
    {
      productId: SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_4,
      label: `${TP}.FN_ORG_PLAN_TIER_4_LABEL`,
      price: '€1500',
      features: `${TP}.FN_ORG_PLAN_TIER_4_FEATURES`,
      canUpgrade: true,
      canDowngrade: true,
      tier: 4,
    },
    {
      productId: SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_5,
      label: `${TP}.FN_ORG_PLAN_TIER_5_LABEL`,
      price: '€1200',
      features: `${TP}.FN_ORG_PLAN_TIER_5_FEATURES`,
      canUpgrade: true,
      canDowngrade: true,
      tier: 5,
    },
    {
      productId: SUBSCRIPTION_PRODUCT_IDS.AOS_TIER_6,
      label: `${TP}.FN_ORG_PLAN_TIER_6_LABEL`,
      price: '€850',
      features: `${TP}.FN_ORG_PLAN_TIER_6_FEATURES`,
      canUpgrade: true,
      canDowngrade: false,
      tier: 6,
    },
  ],
};
